import type { Branded } from "@@/utilities/branded";

type UnixTimestamp = Branded<number, "Unix_Timestamp">;
const toUnix = (date: Date): UnixTimestamp =>
    Math.floor(date.getTime() / 1000) as UnixTimestamp;
const fromUnix = (unix: UnixTimestamp) => new Date(unix * 1000);

export { fromUnix, toUnix };
export type { UnixTimestamp };
